// frontend/src/components/Search/SearchResults.jsx
// 搜尋結果列表元件（包含分頁）

import { Box, Typography, Paper, Pagination, Alert, CircularProgress } from '@mui/material';
import SearchResultCard from './SearchResultCard';

const SearchResults = ({ results, total, page, pageSize, query, loading, error, onPageChange }) => {
  /**
   * 計算總頁數
   */
  const totalPages = Math.ceil(total / pageSize);

  /**
   * 處理分頁變更
   */
  const handlePageChange = (event, value) => {
    onPageChange(value);
    // 滾動到頂部
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // 載入中
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  // 錯誤訊息
  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        {error}
      </Alert>
    );
  }

  // 無搜尋結果
  if (!loading && results.length === 0 && query) {
    return (
      <Paper sx={{ p: 4, mt: 2, textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          找不到相關結果
        </Typography>
        <Typography variant="body2" color="text.secondary">
          試試不同的關鍵字，或使用「+」和「/」組合搜尋
        </Typography>
      </Paper>
    );
  }

  // 尚未搜尋
  if (!query) {
    return null;
  }

  return (
    <Box sx={{ mt: 3 }}>
      {/* 搜尋結果統計 */}
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          找到 <strong>{total}</strong> 筆結果，關鍵字：「<strong>{query}</strong>」
        </Typography>

        {totalPages > 1 && (
          <Typography variant="body2" color="text.secondary">
            第 {page} / {totalPages} 頁
          </Typography>
        )}
      </Box>

      {/* 搜尋結果列表 */}
      {results.map((result) => (
        <SearchResultCard key={result.id} result={result} query={query} />
      ))}

      {/* 分頁器 */}
      {totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            color="primary"
            size="large"
            showFirstButton
            showLastButton
          />
        </Box>
      )}
    </Box>
  );
};

export default SearchResults;
